import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { PrimaryButton, TextField } from '@fluentui/react';
import { CharacterCount } from '../../../CharacterCount/CharacterCount';
const FREEFORM_MAX_LENGTH = 2000;
const FREEFORM_MIN_LENGTH = 10;
/** View component for a "thank you" messagebar with a freeform "what can we improve" text entry. */
export const ThanksAndFreeformView = ({ rating, onChange, value, onSendFreeform, }) => {
    // We require the user to tell us why they are not satisfied.
    const isRequired = rating < 4;
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { required: isRequired, value: value, onChange: onChange, label: 'Feedback', onRenderLabel: (props, defaultRender) => (_jsxs(_Fragment, { children: [defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender(props), _jsxs("p", Object.assign({ style: {
                                marginBlockStart: '0.25em',
                                marginBlockEnd: '0.5em',
                                maxWidth: '600px',
                            } }, { children: [ratingFreeformTextLabel[rating], " Your detailed feedback helps us improve your experience.", isRequired &&
                                    ` Please enter between ${FREEFORM_MIN_LENGTH.toLocaleString()} and ${FREEFORM_MAX_LENGTH.toLocaleString()} characters.`] }))] })), description: (_jsx(CharacterCount, { count: value.length, max: FREEFORM_MAX_LENGTH })), multiline: true, rows: 3, maxLength: FREEFORM_MAX_LENGTH, minLength: FREEFORM_MIN_LENGTH, styles: {
                    field: {
                        width: '25vw',
                        height: '8vh',
                    },
                    root: {
                        marginTop: '20px',
                    },
                } }), _jsx("div", Object.assign({ style: { marginTop: '10px' } }, { children: _jsx(PrimaryButton, { text: 'Send', onClick: onSendFreeform, styles: { flexContainer: { flexDirection: 'row-reverse' } }, iconProps: { iconName: 'Send' }, disabled: isRequired &&
                        (value.length < FREEFORM_MIN_LENGTH ||
                            value.length > FREEFORM_MAX_LENGTH) }) }))] }));
};
const ratingFreeformTextLabel = {
    1: 'What is broken?',
    2: 'What specifically is bad about the layout or content?',
    3: 'What can we do to make this a 5/5?',
    4: 'What should we improve?',
    5: 'Thanks for the feedback!',
};
